import * as React from 'react';
import { LoadingDots } from '@balance-web/loading';

import { useAuth } from '@reckon-web/auth-store';

import { isPortalResponseSuccess } from '../../../services/PortalRestApi/isResponseSuccess';

import { UserInfo } from './UserInfo';
import type { GetUserResponse } from './UserInfoApi';
import { useGetUserQuery } from './UserInfoApi';

type UserInfoContainerProps = {
  helpAndSupportUrl: string;
};
export const UserInfoContainer = ({
  helpAndSupportUrl,
}: UserInfoContainerProps) => {
  const { logout, isAuthenticated } = useAuth();
  const { isLoading, data } = useGetUserQuery();

  if (isLoading) {
    return <LoadingDots label="Loading user" />;
  }

  return (
    (isAuthenticated && isPortalResponseSuccess<GetUserResponse>(data) && (
      <UserInfo
        showLogout
        firstName={data.firstname}
        lastName={data.lastname}
        logoutMenuLabel="Return to Portal Dashboard"
        onHelpClick={() => {
          window.open(helpAndSupportUrl, '_blank')?.focus();
        }}
        onLogoutClick={() => {
          logout({ reasonCode: 'USER_INITIATED' });
        }}
      />
    )) ||
    null
  );
};
